import { SvgIcon, SvgIconProps } from '@mui/material';

export const AiAssistantIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} inheritViewBox>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'>
        <path
          d='M12 6V2H8M8 18l-4 4V8a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H8zM2 12h2M9 11v2M15 11v2M20 12h2'
          stroke='currentColor'
          strokeWidth={1.5}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </SvgIcon>
  );
};
